exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-6d1d54b7]{border:1px solid #d9e0e6;border-radius:3px;padding:20px;margin-bottom:20px}.item .title[data-v-6d1d54b7]{font-size:18px;border-bottom:1px dashed #d9e0e6;padding-bottom:10px;margin-bottom:10px}.w230[data-v-6d1d54b7]{width:230px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6d1d54b7","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/addOrEditFood.vue
// module id = Buds
// module chunks = 0